import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Close from './Close';

const useStyles = makeStyles(() => ({
  root: {
    '&:empty': {
      display: 'none',
    },
  },
}));

const Controls = ({ onClose }) => {
  const classes = useStyles();
  const isClosable = onClose ? true : false;

  return (
    <div className={classes.root}>
      {isClosable ? <Close onClose={onClose} /> : null}
    </div>
  );
};

export default Controls;
